
export const CONNECTION_REGEX = '{{1}{connections.(.*?)}{1}}'
